import * as Yup from "yup";
import Alert from "../../utils/Alert";
import {
  addNewMaterialService,
  editMaterialService,
} from "../../services/materialsService";

export const initialValues = {
  group_name: "",
  afnor: "",
  aisi_sae: "",
  astm: "",
  bts: "",
  sis: "",
  uni: "",
  uns: "",
  wnr: "0.0000",
  din: "",
  en: "",
  jis: "",
  english_group: "",
  persian_group: "",
  class_name: "",
  persian_class: "",
  cost: "",
  density: "",
  machinability: "0.00",
  manufacturer_reference: "",
  link: "",
};

export const initialTouched = {
  group_name: true,
  english_group: true,
  persian_group: true,
  class_name: true,
  persian_class: true,
  cost: true,
  density: true,
  machinability: true,
  link: true,
};

export const onSubmit = async (
  values,
  actions,
  editingMaterial,
  setData,
  dataLength,
  itemsCnt,
  navigate,
) => {
  const formattedValues = {
    ...values,
    machinability: parseFloat(values.machinability),
    wnr: parseFloat(values.wnr),
  };

  try {
    if (editingMaterial) {
      const response = await editMaterialService(
        editingMaterial.id,
        formattedValues,
      );
      if (response.status === 200) {
        setData((prevData) =>
          prevData.map((d) => {
            if (d.id === editingMaterial.id) {
              return response.data;
            }
            return d;
          }),
        );
        Alert("انجام عملیات", "ماده اولیه با موفقیت ویرایش شد", "success");
        navigate(-1);
      }
    } else {
      const response = await addNewMaterialService(formattedValues);
      if (response.status === 200) {
        if (dataLength < itemsCnt) {
          setData((prevData) => [...prevData, response.data]);
        }
        Alert("انجام عملیات", "ماده اولیه با موفقیت افزوده شد", "success");
        actions.resetForm();
      }
    }
  } catch (error) {
    console.error(error);
  }
};

export const validationSchema = Yup.object({
  group_name: Yup.string()
    .required("لطفاً گروه ماده اولیه را مشخص کنید")
    .matches(
      /^[a-zA-Z0-9\s]+$/,
      "لطفاً فقط از حروف الفبای انگلیسی و اعداد استفاده کنید",
    ),
  afnor: Yup.string(),
  aisi_sae: Yup.string(),
  astm: Yup.string(),
  bts: Yup.string(),
  sis: Yup.string(),
  uni: Yup.string(),
  uns: Yup.string(),
  wnr: Yup.string().matches(
    /^\d\.\d{4}$/,
    "لطفاً عدد را با فرمت 0.0000 وارد کنید",
  ),
  din: Yup.string(),
  en: Yup.string(),
  jis: Yup.string(),
  english_group: Yup.string().matches(
    /^[a-zA-Z0-9\s]+$/,
    "لطفاً فقط از حروف الفبای انگلیسی و اعداد استفاده کنید",
  ),
  persian_group: Yup.string().matches(
    /^[0-9\u0600-\u06FF\u200c\s]+$/,
    "لطفاً فقط از حروف الفبای فارسی و اعداد استفاده کنید",
  ),
  class_name: Yup.string()
    .required("لطفاً کلاس ماده اولیه را مشخص کنید")
    .matches(
      /^(?!.*[ا-ی۰-۹]).*$/,
      "لطفاً فقط از حروف الفبای انگلیسی و اعداد استفاده کنید",
    ),
  persian_class: Yup.string().matches(
    /^[0-9\u0600-\u06FF\u200c\s]+$/,
    "لطفاً فقط از حروف الفبای فارسی و اعداد استفاده کنید",
  ),
  cost: Yup.number()
    .typeError("لطفاًَ فقط عدد وارد کنید")
    .min(0, "هزینه نمی‌تواند منفی باشد")
    .required("لطفاً هزینه‌ی یک کیلوگرم از ماده اولیه را وارد کنید"),
  density: Yup.number()
    .typeError("لطفاًَ فقط عدد وارد کنید")
    .min(0, "چگالی نمی‌تواند منفی باشد")
    .required("لطفاً مقدار چگالی را وارد کنید"),
  machinability: Yup.string()
    .matches(
      /^(?:\d{1}\.\d{2}|\d{2}\.\d{2}|\d{1}\.\d{1}|\d{2}\.\d{1}|\d{1,2})$/,
      "لطفاً عدد را با فرمت صحیح وارد کنید",
    )
    .required("مشخص کردن ماشین‌کاری اجباری می‌باشد"),
  manufacturer_reference: Yup.string(),
  link: Yup.string().matches(
    /^(http|https):[/]{2}(www\.)?[a-zA-Z0-9.]+\.[a-zA-Z]{2,}([/]{1}[a-zA-Z0-9&#?~=.:_+-]*)*$/,
    "لطفاً یک آدرس معتبر وارد کنید\nhttps://www.example.com",
  ),
});
